import React, { useState, useEffect, useContext } from "react";
import ReactSwitch from "react-switch";
import ImageInput from "../common/ImageInput";
import { FILES_ENDPOINT, getValue } from "../../utils";
import { ProyectosContext } from "../../context/ProyectosContext";
import { ClientesContext } from "../../context/ClientesContext";
import { AppConfigContext } from "../../context/AppConfigContext";
import SearchableSelect from "../global/SearchableSelect";

// soloBasico: only nombre + identificador (ObraCard options menu).
// configuracion: full settings page inside the obra (no modal to close).
const ObraForm = ({
  handleCancel,
  handleCallback,
  soloBasico = false,
  configuracion = false,
}) => {
  const [src, setSrc] = useState("");

  const appconfig = useContext(AppConfigContext);

  const { clientes, getClientes } = useContext(ClientesContext);

  const { proyecto, postProyecto, setPropiedadProyecto } =
    useContext(ProyectosContext);

  useEffect(() => {
    getClientes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (proyecto && proyecto !== null) {
      handleImg();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [proyecto]);

  const handleImg = () => {
    if (proyecto.idAdjunto && proyecto.idAdjunto !== null) {
      let newSrc = `${FILES_ENDPOINT}/${proyecto.idAdjunto}.png`;
      if (newSrc !== src) {
        setSrc(newSrc);
      }
    }
  };

  const getSrc = () => {
    if (src !== "") {
      return src;
    }
    if (proyecto?.tipo_adjunto && proyecto?.tipo_adjunto !== null) {
      return `${FILES_ENDPOINT}/${proyecto.idAdjunto}.${proyecto.tipo_adjunto}`;
    }
  };

  const handleFile = (file) => {
    setPropiedadProyecto("file", file);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    postProyecto(proyecto, handleCallback);
  };

  const renderClienteForm = () => {
    if (getValue(appconfig, "clients_enabled", "boolean")) {
      return (
        <div className="mb-3">
          <label>Cliente</label>
          {Array.isArray(clientes) && (
            <SearchableSelect
              items={clientes}
              itemText={"nombre"}
              itemValue={"idCliente"}
              modifier={(cliente) =>
                setPropiedadProyecto("idCliente", cliente.value)
              }
              value={proyecto?.idCliente}
            />
          )}
        </div>
      );
    }
  };

  const renderNombre = () => (
    <div className="mb-3">
      <label>Nombre de Obra</label>
      <input
        type="text"
        maxLength={140}
        value={proyecto?.nombre || ""}
        className="form-control"
        placeholder="Ejemplo: Edificio Uno"
        onChange={(e) => setPropiedadProyecto("nombre", e.target.value)}
      />
    </div>
  );

  const renderIdentificador = () => (
    <div className="mb-3">
      <label>Identificador</label>
      <input
        type="text"
        maxLength={140}
        value={proyecto?.identificador || ""}
        className="form-control"
        placeholder="Ejemplo: EDU-01"
        onChange={(e) => setPropiedadProyecto("identificador", e.target.value)}
      />
    </div>
  );

  const renderUbicacion = () => (
    <div className="mb-3">
      <label>Ubicación</label>
      <input
        type="text"
        maxLength={140}
        value={proyecto?.calle || ""}
        className="form-control"
        placeholder="Ejemplo: Cumbres"
        onChange={(e) => setPropiedadProyecto("calle", e.target.value)}
      />
    </div>
  );

  const renderAvance = () => (
    <>
      <div className="d-flex align-items-center mb-3">
        <ReactSwitch
          checked={!!proyecto?.cantidades_enabled}
          onChange={(checked) =>
            setPropiedadProyecto("cantidades_enabled", checked)
          }
        />
        <label className="ms-2 mb-0">Habilitar avance por cantidades</label>
      </div>
      <div className="mb-3">
        <label className="mb-1">Nivel de avance</label>
        <select
          className="form-select"
          value={proyecto?.modo_avance || "destajo"}
          onChange={(e) => setPropiedadProyecto("modo_avance", e.target.value)}
        >
          <option value="destajo">Por destajo</option>
          <option value="partida">Por partida</option>
        </select>
      </div>
      {proyecto?.cantidades_enabled && (
        <div className="mb-3">
          <label className="mb-1">Modo de progreso por defecto</label>
          <select
            className="form-select"
            value={proyecto?.modo_progreso || "percentage"}
            onChange={(e) =>
              setPropiedadProyecto("modo_progreso", e.target.value)
            }
          >
            <option value="percentage">Porcentaje</option>
            <option value="amount">Cantidad</option>
          </select>
        </div>
      )}
      <div className="mb-3">
        <label className="mb-1">Captura por defecto</label>
        <select
          className="form-select"
          value={proyecto?.tipo_captura || "acumulado"}
          onChange={(e) => setPropiedadProyecto("tipo_captura", e.target.value)}
        >
          <option value="acumulado">Acumulado</option>
          <option value="diferencial">Diferencial</option>
        </select>
      </div>
    </>
  );

  const renderImagen = () => (
    <>
      <label className="mb-1">Imagen</label>
      <div className="row mb-4">
        <ImageInput value={getSrc()} modifier={handleFile} />
      </div>
    </>
  );

  const renderBotones = () => (
    <div className="row">
      <div className="col-6 ">
        <button
          type="button"
          onClick={handleCancel}
          className="btn w-100 btn-link text-muted"
        >
          {configuracion ? "Descartar cambios" : "Cancelar"}
        </button>
      </div>
      <div className="col-6 ">
        <button className="btn w-100 btn-primary" type="submit">
          Guardar
        </button>
      </div>
    </div>
  );

  if (soloBasico) {
    return (
      <form onSubmit={onSubmit} className="container px-0">
        {renderNombre()}
        {renderIdentificador()}
        {renderBotones()}
      </form>
    );
  }

  if (configuracion) {
    return (
      <form onSubmit={onSubmit} className="container px-0">
        <h5 className="bold mb-3">General</h5>
        <div className="row">
          <div className="col-12 col-md-6">{renderNombre()}</div>
          <div className="col-12 col-md-6">{renderIdentificador()}</div>
          <div className="col-12">{renderUbicacion()}</div>
        </div>
        {renderClienteForm()}
        <hr />
        <h5 className="bold mb-3">Avance</h5>
        {renderAvance()}
        <hr />
        {renderImagen()}
        {renderBotones()}
      </form>
    );
  }

  return (
    <form onSubmit={onSubmit} className="container px-0">
      <div className="row mb-2">
        <div className="col-12 col-md-6">{renderNombre()}</div>
        <div className="col-12 col-md-6">{renderUbicacion()}</div>
      </div>
      {renderClienteForm()}
      {renderAvance()}
      {renderImagen()}
      {renderBotones()}
    </form>
  );
};

export default ObraForm;
